import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

import router from './router'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)//解决微信分享标题显示的问题


import "@/assets/css/common/style.css"
import rem from './assets/js/rem.js'  //适配rem 引入即生效
import moment from 'moment'//1.导入 monment 文件

import qs from 'qs'//请求数据
import vuex from 'vuex'//vuex
import store from './vuex/store'//vuex
import QRCode from 'qrcodejs2'

import $ from 'jquery'
Vue.prototype.$ = $;

import 'font-awesome/css/font-awesome.css'

import VueBarrel from '@/assets/js/VueBarrel.js';
Vue.use(VueBarrel)


import url_ from './components/url'//全局变量地址
Vue.prototype.URL = url_//挂载到Vue实例上面


import VueLazyload from 'vue-lazyload'//懒加载

// js 公共方法
import func from '@/assets/js/fun.js'
Vue.prototype.$fun = func;

import cookie from '@/assets/js/cookie.js'
Vue.prototype.$cookie = cookie;


Vue.use(
  VueLazyload,

  {
    // attempt: 1,
    // preLoad: 1,//比例
    // throttleWait: 500,//延迟
    // throttleWait: 99900000,//延迟
    loading: require('@/assets/image/common/img_loading.gif')
  }
)



// 全屏滚动 vue-fullpage.js
import 'fullpage.js/vendors/scrolloverflow';
import VueFullpage from 'vue-fullpage.js'
Vue.use(VueFullpage)
// import Carousel3d from 'vue-carousel-3d';//3d切换
// Vue.use(Carousel3d);

// import VueUploadImgs from 'vue-upload-imgs'//图片上传
// Vue.use(VueUploadImgs)


import 'element-ui/lib/theme-chalk/index.css'
import "@/assets/css/element/element.css"//覆盖elemnt的样式
import Ripple from 'vue-ripple-directive'//点击特效

//挂载到原型插件或者方法
Vue.prototype.$QRCode = QRCode;

// import JsEncrypt from 'jsencrypt'
// Vue.prototype.$jsEncrypt = JsEncrypt

// Vue.prototype.$encryptedData = function (publicKey, data) {
//   //new一个对象
//   let encrypt = new JSEncrypt()
//   //设置公钥
//   encrypt.setPublicKey(publicKey)
//   let result = encrypt.encrypt(password)
//   return result
// }
//2.把 moment.js 挂载到全局上（即vue的原型链上）赋值使用
Vue.prototype.$moment = moment;
//3.调用API进行汉化

moment.locale('zh-cn');
//定义活动全局过滤器实现日期格式化
Vue.filter('dateFormat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})





Vue.directive('ripple', Ripple);
Vue.prototype.$qs = qs;//请求数据

Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.use(vuex);

Vue.config.productionTip = false
Vue.component(CollapseTransition.name, CollapseTransition)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',

  // directives: {
  //   time: {
  //     bind: function (el, binding) {
  //       console.log(this.getFormatTime);
  //       el.innerHTML = getFormatTime(binding.value);
  //       //每隔一分钟更新一次
  //       el.__timeout__ = setInterval(function () {
  //         el.innerHTML = getFormatTime(binding.value);
  //       }, 60000);
  //     },
  //     unbind: function (el) {
  //       clearInterval(el.__timeout__);
  //       delete el.__timeout__;
  //     }
  //   }
  // },


})



// WEBPACK FOOTER //
// ./src/main.js